import { apiInstance } from 'api/utils';

const intelifloApi = {
  verifyIoCode: ({ code }: { code: string }) => {
    return apiInstance.request({
      method: 'POST',
      url: '/provider/sources/intelligent-office/tokens',
      data: {
        code: code
      }
    });
  },
  checkAuthStatus: () => {
    return apiInstance.request({
      method: 'GET',
      url: '/provider/sources/intelligent-office/check-authorization'
    });
  },
  importClients: (data: ClientRequest) => {
    return apiInstance.request({
      method: 'POST',
      url: '/provider/sources/intelligent-office/clients',
      data
    });
  },
  importPolicies: (data: any) => {
    return apiInstance.request({
      method: 'POST',
      url: '/provider/sources/intelligent-office/policies',
      data
    });
  }
};

export interface ClientRequest {
  first_name?: string;
  last_name?: string;
  date_of_birth?: string;
  external_reference?: string;
  trust_name?: string;
  corporate_name?: string;
}

export default {
  intelifloApi
};
